import { render, staticRenderFns } from "./MakeRepairList.vue?vue&type=template&id=6788abc0"
import script from "./MakeRepairList.vue?vue&type=script&lang=js"
export * from "./MakeRepairList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports